import Axios from 'axios';
import notify from 'devextreme/ui/notify'

const URL = 'api/system/equipment'
const LINKED_URL = 'api/system/li'

export default {
    namespaced: true,
    state: {
        models: [],
        showActive: true
    },
    mutations: {
        setModels(state, mdls) {
            state.models = mdls ? mdls : [];
        },
        setStat(state, stat = false) {
            state.showActive = stat;
        }
    },
    actions: {
        loadInactive({ commit }, stat) {
            commit('setStat', stat);
            return;
        },
        getModels({ commit, state }) {
            var active = state.showActive ? 1 : 0

            return Axios.get(URL + '?active=' + active)
                .then(response => {
                    commit('setModels', response.data.msg);
                    return response.data.success;
                })
                .catch(err => {
                    notify(err.message, 'error', 4000);
                    return;
                })
        },
        addModel({ commit }, dev) {
            debugger;
            return Axios.post(URL, dev)
                .then(response => {
                    var type = response.data.success ? 'success' : 'error'
                    notify(response.data.msg, type, 4000)
                    return response.data.success;
                })
        },
        updateModel({ commit }, dev) {
            debugger;
            this.dispatch('updateStat', true)
            return Axios.put(URL + '?id=' + dev.id, dev)
                .then(response => {
                    var type = response.data.success ? 'success' : 'error'
                    notify(response.data.msg, type, 4000)

                    this.dispatch('updateStat', false)

                    return this.dispatch('sysEquipment/getModels');
                })
                .catch(err => {

                    notify(err.message, 'error', 4000)
                    return false;
                })
        },
        removeModel({ commit }, id) {
            this.dispatch('updateStat', true);

            return Axios.delete(URL + '?id=' + id)
                .then(response => {
                    var type = response.data.success ? 'success' : 'error'

                    notify(response.data.msg, type, 4000);

                    this.dispatch('updateStat', false)

                    return this.dispatch('sysEquipment/getModels');
                })
                .catch(err => {
                    notify(err.message, 'error', 4000);
                    return false;
                })
        },
        addLinkedItem({ commit }, itm) {
            this.dispatch('updateStat', true)
            return Axios.post(LINKED_URL, itm)
                .then(response => {
                    debugger;
                    var type = response.data.success ? 'success' : 'error'
                    notify(response.data.msg, type, 4000);
                    this.dispatch('updateStat', false)
                    return type === 'success'
                })
                .catch(err => {
                    notify(err.message, 'error', 4000)

                    this.dispatch('updateStat', false)

                    return false
                })
        },
        removeLinkedItem({ commit }, id) {
            debugger
            this.dispatch('updateStat', true)
            return Axios.delete(LINKED_URL + '?id=' + id)
                .then(response => {
                    debugger
                    var type = response.data.success ? 'success' : 'error'

                    notify(response.data.msg, type, 4000)

                    this.dispatch('updateStat', false)

                    return type === 'success'
                })
                .catch(err => {
                    notify(err.message)
                    this.dispatch('updateStat', false)
                    return false;
                });
        }
    },
    getters: {
        models: state => state.models,
        showActive: state => state.showActive
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/admin/LinkDSG/dsgEquipment.js